import Vue from 'vue';
import VueRouter from 'vue-router';
const _import = require('./_import_production');

Vue.use(VueRouter);

import Layout from '../views/layout/Layout';

export const constantRouterMap = [
  {
    path: '/login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/authredirect',
    component: _import('login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: _import('error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: _import('error/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: '首页',
    hidden: true,
    children: [
      {
        path: 'dashboard',
        component: _import('dashboard/index')
      }
    ]
  },
  {
    path: '/introduction',
    component: Layout,
    redirect: '/introduction/index',
    icon: 'form',
    noDropdown: true,
    children: [
      {
        path: 'index',
        component: _import('introduction/index'),
        name: '简述'
      }
    ]
  },
  {
    path: '/print-payment',
    component: _import('print/payment'),
    hidden: true
  }
];

export default new VueRouter({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});

export const asyncRouterMap = [
  {
    path: '/baseManager',
    component: Layout,
    name: '基础配置管理',
    icon: 'setting',
    authority: 'baseManager',
    children: [
      {
        path: 'userManager',
        icon: 'fa-user',
        component: resolve => require(['@/views/admin/user/user'], resolve),
        name: '用户管理',
        authority: 'userManager'
      },
      {
        path: 'menuManager',
        icon: 'category',
        component: resolve => require(['@/views/admin/menu/menu'], resolve),
        name: '菜单管理',
        authority: 'menuManager'
      },
      {
        path: 'groupManager',
        icon: 'group_fill',
        component: resolve => require(['@/views/admin/group/group'], resolve),
        name: '角色权限管理',
        authority: 'groupManager'
      },
      {
        path: 'groupTypeManager',
        icon: 'fa-users',
        component: resolve => require(['@/views/admin/groupType/groupType'], resolve),
        name: '角色类型管理',
        authority: 'groupTypeManager'
      },
      {
        path: 'gateLogManager',
        icon: 'viewlist',
        component: resolve => require(['@/views/admin/gateLog/gateLog'], resolve),
        name: '操作日志管理',
        authority: 'gateLogManager'
      },
      {
        path: 'vtEmployeeManager',
        component: resolve => require(['@/views/admin/employeeDemo'], resolve),
        name: 'VT员工列表',
        authority: 'vtEmployeeManager'
      }
    ]
  },
  {
    path: '/authManager',
    component: Layout,
    name: '基础配置管理',
    icon: 'setting',
    authority: 'authManager',
    children: [
      {
        path: 'serviceManager',
        component: resolve => require(['@/views/auth/service/service'], resolve),
        name: '用户管理',
        authority: 'serviceManager'
      }
    ]
  },
  {
    path: '/monitorManager',
    component: Layout,
    name: '监控模块管理',
    icon: 'setting',
    authority: 'monitorManager',
    children: [
      {
        path: 'serviceEurekaManager',
        component: resolve => require(['@/views/monitor/eureka/eureka'], resolve),
        name: 'Eureka注册中心',
        authority: 'serviceEurekaManager'
      },
      {
        path: 'serviceMonitorManager',
        component: resolve => require(['@/views/monitor/service/service'], resolve),
        name: '服务状态监控',
        authority: 'serviceMonitorManager'
      },
      {
        path: 'serviceZipkinManager',
        component: resolve => require(['@/views/monitor/zipkin/zipkin'], resolve),
        name: '服务状态监控',
        authority: 'serviceZipkinManager'
      }
      // {
      //   path: 'hstDemandManager',
      //   component: resolve => require(['@/views/demand/demand'], resolve),
      //   name: '需求管理',
      //   authority: 'hstDemandManager'
      // },
      // {
      //   path: 'hstDemandOrderManager',
      //   component: resolve => require(['@/views/demand/demandOrder'], resolve),
      //   name: '需求订单管理',
      //   authority: 'hstDemandOrderManager'
      // }
    ]
  },
  {
    path: '/demandManager',
    component: Layout,
    name: '需求',
    icon: 'setting',
    authority: 'demandManager',
    children: [
      {
        path: 'hstProductManager',
        component: resolve => require(['@/views/demand/product'], resolve),
        name: '产品管理',
        authority: 'hstProductManager'
      },
      {
        path: 'hstDemandManager',
        component: resolve => require(['@/views/demand/demand'], resolve),
        name: '需求管理',
        authority: 'hstDemandManager'
      },
      {
        path: 'hstDemandOrderManager',
        component: resolve => require(['@/views/demand/demandOrder'], resolve),
        name: '订单管理',
        authority: 'hstDemandOrderManager'
      }
    ]
  }
];
